import PropTypes from "prop-types";
import React from "react";

import { useOnArrowClick } from "./hooks";
import { Arrow, arrowSvg, Line, Root } from "./styled";

/**
 * Renders a separator between re-designed origin and destination sections (part of re-imagine postcodes epic).
 * The separator is rendered on desktop resolutions only and offers an arrow icon to flip the sections (aka "Create import shipment").
 */
export const OriginDestinationSeparator = ({ switchRef }) => {
  const line = <Line aria-hidden="true" />;

  return (
    <Root>
      {line}
      <Arrow type="button" onClick={useOnArrowClick(switchRef)}>
        {arrowSvg}
      </Arrow>
      {line}
    </Root>
  );
};

OriginDestinationSeparator.propTypes = {
  /**
   * Reference to the switch button that toggles the origin and destination sections.
   */
  switchRef: PropTypes.object.isRequired,
};
